import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './components/Layout/MainLayout';
import Home from './pages/Home';
import Skills from './pages/Skills';
import SkillDetail from './pages/SkillDetail';
import SkillImport from './pages/SkillImport';
import Experts from './pages/Experts';
import ExpertDetail from './pages/ExpertDetail';
import ExpertChat from './pages/ExpertChat';
import Upload from './pages/Upload';
import Publish from './pages/Publish';
import Login from './pages/Login';
import Register from './pages/Register';

// 管理后台页面
import AdminDashboard from './pages/Admin/Dashboard';
import SkillManagement from './pages/Admin/SkillManagement';
import ExpertManagement from './pages/Admin/ExpertManagement';
import CategoryManagement from './pages/Admin/CategoryManagement';
import UserManagement from './pages/Admin/UserManagement';
import OrderManagement from './pages/Admin/OrderManagement';
import AuditCenter from './pages/Admin/AuditCenter';
import NotFound from './pages/NotFound';
import { ProtectedRoute, RequireAdmin } from './components/ProtectedRoute';

// Ant Design 主题配置
const themeConfig = {
  token: {
    colorPrimary: '#7c3aed',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#3b82f6',
    borderRadius: 8,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  },
};

function App() {
  return (
    <ConfigProvider theme={themeConfig}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* 使用新布局的页面 */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/skill/:id" element={<SkillDetail />} />
              <Route path="/skill-import" element={<ProtectedRoute><SkillImport /></ProtectedRoute>} />
              <Route path="/experts" element={<Experts />} />
              <Route path="/expert/:id" element={<ExpertDetail />} />
              <Route path="/expert-chat/:id" element={<ExpertChat />} />
              <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
              <Route path="/publish" element={<ProtectedRoute><Publish /></ProtectedRoute>} />
              {/* 历史路径兼容：/publish-skill 重定向到 /publish */}
              <Route path="/publish-skill" element={<ProtectedRoute><Publish /></ProtectedRoute>} />

              {/* 管理后台（统一前端鉴权 + RBAC） */}
              <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
              <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
              <Route path="/admin/skills" element={<RequireAdmin><SkillManagement /></RequireAdmin>} />
              <Route path="/admin/experts" element={<RequireAdmin><ExpertManagement /></RequireAdmin>} />
              <Route path="/admin/categories" element={<RequireAdmin><CategoryManagement /></RequireAdmin>} />
              <Route path="/admin/users" element={<RequireAdmin><UserManagement /></RequireAdmin>} />
              <Route path="/admin/orders" element={<RequireAdmin><OrderManagement /></RequireAdmin>} />
              <Route path="/admin/audit" element={<RequireAdmin><AuditCenter /></RequireAdmin>} />

              {/* 404 兜底（带 MainLayout 侧边栏） */}
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* 独立页面（不使用侧边栏布局） */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
